/** Shopify CDN: Minification failed

Line 55:4 Transforming let to the configured target environment ("es5") is not supported yet
Line 56:4 Transforming let to the configured target environment ("es5") is not supported yet
Line 57:4 Transforming let to the configured target environment ("es5") is not supported yet
Line 58:4 Transforming let to the configured target environment ("es5") is not supported yet
Line 62:6 Transforming let to the configured target environment ("es5") is not supported yet
Line 63:11 Transforming let to the configured target environment ("es5") is not supported yet
Line 64:8 Transforming let to the configured target environment ("es5") is not supported yet
Line 74:4 Transforming let to the configured target environment ("es5") is not supported yet
Line 75:9 Transforming let to the configured target environment ("es5") is not supported yet
Line 76:6 Transforming let to the configured target environment ("es5") is not supported yet
... and 4 more hidden warnings

**/
/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

(function() {
    'use strict'
  
    let tabsClass      = 'tabs'
    let tabClass       = 'tab'
    let tabButtonClass = 'tab-button'
    let activeClass    = 'active'
  
    /* Activates the chosen tab and deactivates the rest */
    function activateTab(chosenTabElement) {
      let tabList = chosenTabElement.parentNode.querySelectorAll('.'+tabClass)
      for (let i = 0; i < tabList.length; i++) {
        let tabElement = tabList[i]
        if (tabElement.isEqualNode(chosenTabElement)) {
          tabElement.classList.add(activeClass)
        } else {
          tabElement.classList.remove(activeClass)
        }
      }
    }
  
    /* Initialize each tabbed container */
    let tabbedContainers = document.body.querySelectorAll('.'+tabsClass)
    for (let i = 0; i < tabbedContainers.length; i++) {
      let tabbedContainer = tabbedContainers[i]
  
      /* List of tabs for this tabbed container */
      let tabList = tabbedContainer.querySelectorAll('.'+tabClass)
  
      /* Make the first tab active when the page loads */
      activateTab(tabList[0])
  
      /* Activate a tab when you click its button */
      for (let i = 0; i < tabList.length; i++) {
        let tabElement = tabList[i]
        let tabButton = tabElement.querySelector('.'+tabButtonClass)
        tabButton.addEventListener('click', function(event) {
          event.preventDefault()
          activateTab(event.target.parentNode)
        })
      }
  
    }
  
  })()


// $(window).scroll(function() {    
//         var scroll = $(window).scrollTop();
// var checking= jQuery('header.header.header--inline').height();    
//         if(scroll > checking){
//           $('div#shopify-section-header nav.nav-bar').addClass('custom_header_sticky');
//         }
//         else if(scroll< checking){
//           $('div#shopify-section-header nav.nav-bar').removeClass('custom_header_sticky');
//         }
//       });

$(window).scroll(function(e) {    
  e.preventDefault();
  var scroll = $(window).scrollTop();
  var checking= jQuery('#shopify-section-header').height();    
  if(scroll > checking){
    $('div#shopify-section-header nav.nav-bar, .main-top-bar').addClass('custom_header_sticky');
    $('body').addClass('body_product');
    var TotalHeight = parseInt($('.main-top-bar.custom_header_sticky').outerHeight() + $('div#shopify-section-header nav.nav-bar.custom_header_sticky').outerHeight());
    if($('body').hasClass('template-product')){
      document.querySelector('.product-block-list__item--info .card.card--collapsed.card--sticky').style.setProperty('--card-top', TotalHeight + 'px');
    }
  }
  else if(scroll < checking){
   $('div#shopify-section-header nav.nav-bar, .main-top-bar').removeClass('custom_header_sticky');
    if($('body').hasClass('template-product')){
      document.querySelector('.product-block-list__item--info .card.card--collapsed.card--sticky').style.setProperty('--card-top', '0');
    }
  }
});

$.fn.isInViewport = function() {
    var elementTop = $(this).offset().top;
    var elementBottom = elementTop + $(this).outerHeight();
    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();
    return elementBottom > viewportTop && elementTop < viewportBottom;
};

function handleViewport() {
    if ($(window).width() <= 767) {
      if ($('.product-block-list__item--info .product-form__add-button').isInViewport()) {
          $('.fixed-atc-btn').removeClass('mbl-fixed');
      } else {
          $('.fixed-atc-btn').addClass('mbl-fixed');
      }
    } else {
        $('.fixed-atc-btn').removeClass('mbl-fixed');
    }
}

$(window).on('resize scroll', function() {
    handleViewport();
});

$(document).ready(function() {
    handleViewport();
});

$(document).on('click','.fixed-atc-btn button',function(){
  $('.product-block-list__item--info .product-form__add-button[data-action="add-to-cart"]').trigger('click')
})